<template>
  <div class="changepwd">
    <el-container>
      <el-header class="pwdheader">{{this.$store.getters.getHeaderContent}}</el-header>
      <el-main class="pwdmain">
        <!--<div style="height: 600px;">-->
        <!--<el-steps direction="vertical" :active="active" finish-status="success">-->
        <!--<el-step title="step 1"></el-step>-->
        <!--<el-step title="step 2"></el-step>-->
        <!--<el-step title="step 3" description="这是一段很长很长很长的描述性文字"></el-step>-->
        <!--</el-steps>-->
        <!--</div>-->
        <!--<el-button style="margin-top: 12px;" @click="next">下一步</el-button>-->
        <el-form ref="form" :rules="rules" :model="form" label-width="150px">
          <img class="llogo" src="../../assets/bes_logo.png"/>
          <el-form-item label="Old Password" prop="opwd">
            <el-input v-model="form.opwd" placeholder="Please input your current password!"
                      show-password></el-input>
          </el-form-item>
          <el-form-item label="New Password" prop="npwd">
            <el-input v-model="form.npwd" placeholder="Please input your new password!"
                      show-password></el-input>
          </el-form-item>
          <el-form-item label="Conform Password" prop="cpwd">
            <el-input v-model="form.cpwd" placeholder="Please input your new password again!"
                      show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">Submit</el-button>
            <el-button @click="onCancel">Cancel</el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axios from 'axios'
import md5 from 'js-md5';

export default {
  name: "changepwd",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('please input password!'));
      } else {
        if (this.form.npwd !== '') {
          this.$refs.form.validateField('cpwd');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('please input password!'));
      } else if (value !== this.form.npwd) {
        callback(new Error('The two passwords are inconsistent!'));
      } else {
        callback();
      }
    };
    return {
      active: 0,
      form: {
        opwd: '',
        npwd: '',
        cpwd: '',
      },
      rules: {
        opwd: [
          {required: true, message: 'please input old password', trigger: 'blur'},
          {min: 6, max: 16, message: 'length must more than than 6 and less than 11', trigger: 'blur'}
        ],
        npwd: [
          {required: true, message: 'please input new password', trigger: 'change'},
          {min: 6, max: 16, message: 'length must more than than 6 and less than 11', trigger: 'blur'},
          {validator: validatePass, trigger: 'blur'}
        ],
        cpwd: [
          {required: true, message: 'please input new password', trigger: 'change'},
          {min: 6, max: 16, message: 'length must more than than 6 and less than 11', trigger: 'blur'},
          {validator: validatePass2, trigger: 'blur'}
        ]
      },
    }
  },
  methods: {
    onCancel() {
      this.$router.push("/login")
      window.localStorage.clear()
      history.pushState(null, null, document.URL)
      window.addEventListener(
        "popstate",
        function (e) {
          history.pushState(null, null, document.URL)
        },
        false
      )
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let postData = {
            user: window.localStorage.getItem("token_key"),
            token: window.localStorage.getItem('token'),
            project_id: "project_id",
            old_password: md5(this.form.opwd),
            new_password: md5(this.form.npwd)
          }
          axios.post(this.$store.getters.getCmsServer + "DBUserChangePwd", postData).then(response => {  //生产
            let errNo = response.data.errno
            let errStr = response.data.errstr
            if (errNo == "0") {
              alert('Change Password Success!');
              this.$router.push("/login")
              window.localStorage.clear()
              history.pushState(null, null, document.URL)
              window.addEventListener(
                "popstate",
                function (e) {
                  history.pushState(null, null, document.URL)
                },
                false
              )
            } else {
              alert(errStr);
            }
          })
        } else {
          console.log('error submit!');
          return false;
        }
      });
    },
  }
}
</script>

<style lang="stylus" scoped>
.changepwd {
  width 100%
  height 920px
}

.pwdheader {
  height: 100px
  width: 100%
  font-size 30px
  color #ccc
  line-height 50px
  text-align center
}

.pwdmain {
  background-color white
  margin auto
  position absolute
  border-width 5px
  border-radius 1%
  left 0
  right 0
  top 25%
  height 400px
  width 700px
  background-color #ccc
  text-align center
}

.llogo
  position relative
  height 50px
  margin-bottom 20px

</style>



// WEBPACK FOOTER //
// src/components/passwd/changepwd.vue